<template>
  <l-tile-layer
    :url="basemap.url"
    :attribution="basemap.attribution"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { LTileLayer } from 'vue2-leaflet'
import defaultMaps from '@/components/builder/MapSettings/defaultMaps'
import { BasemapTypes } from '@/types'
import { MAP_CONFIG_KEY } from '@/constants'

const components: { LTileLayer: typeof LTileLayer } = {
  LTileLayer,
}

@Component({ components })
export default class BasemapLayer extends Vue {
  get basemapType () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[MAP_CONFIG_KEY].basemapType
  }

  get basemapDefault () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[MAP_CONFIG_KEY].basemapDefault
  }

  get basemapCustom () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[MAP_CONFIG_KEY].basemapCustom
  }

  get basemap () {
    if (this.basemapType === BasemapTypes.DEFAULT) {
      return defaultMaps.find(i => i.id === this.basemapDefault) || defaultMaps[0]
    } else if (this.basemapType === BasemapTypes.CUSTOM) {
      return this.basemapCustom
    } else {
      return {
        url: '',
        attribution: '',
      }
    }
  }
}

</script>
